import { render, staticRenderFns } from "./AboutCollaborationsIndex.vue?vue&type=template&id=69cae356&"
import script from "./AboutCollaborationsIndex.vue?vue&type=script&lang=js&"
export * from "./AboutCollaborationsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports